import { render } from "./NormalForm.vue?vue&type=template&id=2e4d9350"
import script from "./NormalForm.vue?vue&type=script&lang=js"
export * from "./NormalForm.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__